const isInteger = value => {
  return (
    !isNaN(value) &&
    (function (x) {
      return (x | 0) === x
    })(parseFloat(value))
  )
}

export default isInteger



// WEBPACK FOOTER //
// ./src/utility/isInteger.js